// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__JCxu_","checkboxCol":"Table_checkboxCol__po2KG","emailCol":"Table_emailCol__3j2NP","actionCol":"Table_actionCol__21O7N"};